import { useConfigContext } from 'contexts/config';
import { useSportContext } from 'contexts/sport';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

export const useEnabledWheelByRarity = () => {
  const {
    flags: {
      marketDailyWheelBySportAndRarity = {
        baseball: { limited: false, common: false },
        football: { limited: false, common: false },
        nba: { limited: false, common: false },
      },
      useAdminWheelConfig = false,
    },
  } = useFeatureFlags();
  const { wheel } = useConfigContext();
  const { sport } = useSportContext();

  if (!useAdminWheelConfig) {
    return {
      limited: marketDailyWheelBySportAndRarity[sport.toLowerCase()]?.limited,
      common: marketDailyWheelBySportAndRarity[sport.toLowerCase()]?.common,
    };
  }

  return {
    limited: wheel.limitedWheelConfig !== null,
    common: wheel.commonWheelConfig !== null,
  };
};
